import {
  LocationFormControl,
  PricelistFormControl,
  SectionColumn,
  SectionDivider,
  SelectMenuProps,
  SelectSection,
  StyledInputLabel,
  StyledLocationSelect,
  StyledMenuItem,
  StyledPricelistSelect,
  StyledTenantSelect,
  TenantFormControl
} from './pricelist-path-selection.styles';

import { useSelector } from 'react-redux';
import { productsSelectors } from '../../../store/products';
import { RootState } from '../../../store/store';
import { singleProductSelectors } from '../../../store/single-product';
import { FC } from 'react';
import { SelectChangeEvent } from '@mui/material';
import { Location } from '../../../types/index';

interface PricelistPathSelectionProps {
  handleSelectChange: (event: SelectChangeEvent<any>) => void;
  showPricelist: boolean;
}

export const PricelistPathSelection: FC<PricelistPathSelectionProps> = ({
  handleSelectChange,
  showPricelist
}) => {
  const tenantsList = useSelector((state: RootState) =>
    productsSelectors.selectTenantsAndLocations(state.products)
  );

  const currentTenantId = useSelector((state: RootState) =>
    singleProductSelectors.selectCurrentTenant(state.singleProduct)
  );

  const tenantsKeys = Object.keys(tenantsList);

  const currentLocationId = useSelector((state: RootState) =>
    singleProductSelectors.selectCurrentLocation(state.singleProduct)
  );

  const currentPricelistId = useSelector((state: RootState) =>
    singleProductSelectors.selectCurrentPricelist(state.singleProduct)
  );

  function getLocation() {
    const locations = tenantsList[currentTenantId].locations;
    const location: Location = { locationId: '', locationName: '', pricelists: [] };
    for (let index in locations) {
      if (locations[index].locationId === currentLocationId)
        return tenantsList[currentTenantId].locations[parseInt(index)];
    }
    return location;
  }

  return (
    <div>
      <SelectSection>
        <SectionColumn width={'180px'}>
          <TenantFormControl size='small'>
            <StyledInputLabel id='tenant-select-label' isDisabled={false}>
              Store brand *
            </StyledInputLabel>
            <StyledTenantSelect
              name='tenantId'
              id='tenant-select'
              value={currentTenantId}
              label='Store brand *'
              onChange={handleSelectChange}
              MenuProps={SelectMenuProps}
            >
              {tenantsKeys.map((tenant) => (
                <StyledMenuItem
                  id={tenantsList[tenant].tenantId}
                  key={tenantsList[tenant].tenantId}
                  value={tenantsList[tenant].tenantId}
                >
                  {tenantsList[tenant].tenantName}
                </StyledMenuItem>
              ))}
            </StyledTenantSelect>
          </TenantFormControl>
        </SectionColumn>
        <SectionColumn width={'180px'}>
          <LocationFormControl size='small' isDisabled={currentTenantId === ''}>
            <StyledInputLabel id='location-select-label' isDisabled={currentTenantId === ''}>
              Store location *
            </StyledInputLabel>
            <StyledLocationSelect
              name='locationId'
              id='location-select'
              value={currentLocationId}
              label='Store location *'
              disabled={currentTenantId === ''}
              onChange={handleSelectChange}
              MenuProps={SelectMenuProps}
              isDisabled={currentTenantId === ''}
            >
              {currentTenantId !== '' &&
                tenantsList[currentTenantId] &&
                tenantsList[currentTenantId].locations.map((location) => {
                  return (
                    <StyledMenuItem
                      id={location.locationId}
                      key={location.locationId}
                      value={location.locationId}
                    >
                      {location.locationName}
                    </StyledMenuItem>
                  );
                })}
            </StyledLocationSelect>
          </LocationFormControl>
        </SectionColumn>
        {showPricelist && (
          <SectionColumn width={'180px'}>
            <PricelistFormControl size='small' isDisabled={currentLocationId === ''}>
              <StyledInputLabel id='pricelist-select-label' isDisabled={currentLocationId === ''}>
                Store Pricelist *
              </StyledInputLabel>
              <StyledPricelistSelect
                name='pricelistId'
                id='pricelist-select'
                value={currentPricelistId}
                label='Store pricelist *'
                disabled={currentLocationId === ''}
                onChange={handleSelectChange}
                MenuProps={SelectMenuProps}
                isDisabled={currentLocationId === ''}
              >
                {currentTenantId !== '' &&
                  tenantsList[currentTenantId] &&
                  getLocation().pricelists.map((pricelist) => {
                    return (
                      <StyledMenuItem
                        id={pricelist.pricelistId}
                        key={pricelist.pricelistId}
                        value={pricelist.pricelistId}
                      >
                        {pricelist.pricelistName}
                      </StyledMenuItem>
                    );
                  })}
              </StyledPricelistSelect>
            </PricelistFormControl>
          </SectionColumn>
        )}
      </SelectSection>
      <SectionDivider />
    </div>
  );
};
